import script from "./TreatmentPlanDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./TreatmentPlanDetail.vue?vue&type=script&setup=true&lang=ts"

import "./TreatmentPlanDetail.vue?vue&type=style&index=0&id=5d3108c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d3108c4"]])

export default __exports__